/**
 * Golden Koi Fish Sprite
 *
 * Rare fish worth 5 lbs. Fast swimmer, elegant shape.
 *
 * Size: 20x14 pixels
 * Animation: 2 frames (flowing tail)
 */

import type { SpriteDefinition } from '../../utils/types';
import { GOLDEN_KOI_PALETTE } from '../palettes/fish';

// Pixel grid: 0=transparent, 1-7=palette colors
// Grid reads left-to-right, top-to-bottom

const frame1 = [
  [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 3, 3, 2, 2, 2, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 3, 2, 2, 2, 2, 2, 2, 3, 3, 3, 1, 0, 0, 0, 0, 0],
  [0, 0, 1, 3, 2, 2, 1, 1, 2, 2, 2, 2, 3, 3, 3, 1, 0, 0, 0, 0],
  [0, 1, 7, 3, 2, 2, 1, 6, 1, 2, 2, 2, 3, 3, 3, 5, 1, 1, 0, 0],
  [1, 7, 7, 3, 2, 2, 1, 1, 2, 2, 2, 3, 3, 3, 5, 5, 5, 5, 1, 0],
  [1, 7, 7, 3, 3, 2, 2, 2, 2, 2, 3, 3, 3, 5, 5, 5, 5, 5, 5, 1],
  [1, 7, 3, 3, 3, 2, 2, 2, 2, 3, 3, 3, 5, 5, 5, 5, 5, 5, 1, 0],
  [0, 1, 3, 3, 3, 3, 2, 2, 3, 3, 3, 5, 5, 5, 5, 5, 1, 1, 0, 0],
  [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 5, 5, 5, 5, 5, 1, 0, 0, 0, 0],
  [0, 0, 0, 1, 3, 3, 3, 3, 3, 5, 5, 5, 5, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 1, 3, 3, 5, 5, 5, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

// Frame 2: tail flows up
const frame2 = [
  [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 3, 3, 2, 2, 2, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 3, 2, 2, 2, 2, 2, 2, 3, 3, 3, 1, 0, 0, 0, 0, 0],
  [0, 1, 1, 3, 2, 2, 1, 1, 2, 2, 2, 2, 3, 3, 3, 1, 0, 0, 0, 0],
  [1, 7, 7, 3, 2, 2, 1, 6, 1, 2, 2, 2, 3, 3, 3, 5, 1, 0, 0, 0],
  [1, 7, 7, 3, 2, 2, 1, 1, 2, 2, 2, 3, 3, 3, 5, 5, 5, 1, 0, 0],
  [0, 1, 7, 3, 3, 2, 2, 2, 2, 2, 3, 3, 3, 5, 5, 5, 5, 5, 1, 0],
  [0, 1, 7, 3, 3, 2, 2, 2, 2, 3, 3, 3, 5, 5, 5, 5, 5, 5, 5, 1],
  [0, 0, 1, 3, 3, 3, 2, 2, 3, 3, 3, 5, 5, 5, 5, 5, 5, 1, 1, 0],
  [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 5, 5, 5, 5, 5, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 1, 3, 3, 3, 3, 5, 5, 5, 5, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 3, 5, 5, 5, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const GOLDEN_KOI: SpriteDefinition = {
  name: 'goldenKoi',
  width: 20,
  height: 14,
  frames: [frame1, frame2],
  palette: GOLDEN_KOI_PALETTE,
  animation: {
    frameRate: 5, // Slightly faster animation for flowing feel
    loop: true,
  },
};
